// extracted by mini-css-extract-plugin
export default {"root":"ErrorPage-root","logo":"ErrorPage-logo","image":"ErrorPage-image"};